export default __webpack_public_path__ + "static/media/home-bg.70db41e0.png";